// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__rc7c_","content":"GlobalSearch_content__3SMSG"};